import { createSlice } from '@reduxjs/toolkit'

import { EAnnouncementType } from '~/features/announcements/types'
import { NewsApi } from '~/services/web/news'

export interface NotificationNoticesState {
  notices: { [key in EAnnouncementType]: number } | null
  currentListUnreadIds: number[] | null
}

const initialState: NotificationNoticesState = {
  notices: null,
  currentListUnreadIds: null,
}

const NotificationNoticesSlice = createSlice({
  name: 'NotificationNotices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(NewsApi.getNotice.matchFulfilled, (state, { payload }) => {
      state.notices = {
        ...state.notices,
        ...payload.data.notices,
      }
    })
    builder.addMatcher(NewsApi.getLive.matchPending, (state) => {
      state.currentListUnreadIds = null
    })
    builder.addMatcher(NewsApi.getLive.matchFulfilled, (state, { payload }) => {
      const list = payload.info?.Datas || payload.info?.data || []
      const unreadIds = list.filter((announcement) => !!announcement.notice).map((announcement) => announcement.id)
      state.currentListUnreadIds = unreadIds.length ? unreadIds : null
    })
    builder.addMatcher(NewsApi.getLivePost.matchFulfilled, (state, { payload }) => {
      // 接口报错时返回 "info": "参数错误"，payload.info.id 可能会报错
      if (state.currentListUnreadIds === null || !payload?.info?.id) {
        return
      }
      const currentId = payload.info.id
      const unreadIds = state.currentListUnreadIds.filter((id) => id !== currentId)
      state.currentListUnreadIds = unreadIds
    })
  },
})

export default NotificationNoticesSlice
